import React from 'react'
import { usePostRequest } from '../hooks/request'
import { QQC_QUARTERLY_ITEM_LIST } from '../urls'
import QqcQuarterlyItemForm from './QqcQuarterlyItemForm'

export default function QqcQuarterlyItemCreate({ onCancel, onSuccess, finance, qqcQuarterlyId }) {
    const monthCreate = usePostRequest({ url: QQC_QUARTERLY_ITEM_LIST.replace('{qqcQuarterlyId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <QqcQuarterlyItemForm
                finance={finance}
                qqcQuarterlyId={qqcQuarterlyId}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
